import { PureComponent } from 'react';
import SafeAnchor from 'react-bootstrap/lib/SafeAnchor';
import mapProps from 'map-props';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import propsMapping from './propsMapping';

class Item extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    eventKey: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    pageLink: PropTypes.string,
  };

  handleClick = (e) => {
    const { eventKey, onClick } = this.props;

    e.preventDefault();

    onClick(eventKey);
  };

  render() {
    const { children, disabled, pageLink } = this.props;

    return (
      <SafeAnchor
        disabled={disabled}
        href={pageLink}
        onClick={this.handleClick}
      >
        {children}
      </SafeAnchor>
    );
  }
}

export default withRouter(mapProps(propsMapping)(Item));
